import { render } from "./ConfirmPassword.vue?vue&type=template&id=4a941603"
import script from "./ConfirmPassword.vue?vue&type=script&lang=js"
export * from "./ConfirmPassword.vue?vue&type=script&lang=js"
script.render = render

export default script